import _ from 'lodash'
import qs from 'qs'

import { Dictionary } from './types'

export function parseGetParams(query: string) {
  const parsedQuery = _.startsWith(query, '?') ? query.substring(1) : query
  return qs.parse(parsedQuery, { allowDots: true })
}

export function stringifyGetParams(query: object) {
  return qs.stringify(query, { allowDots: true })
}

export function formatUrl(base?: string, path?: string, params?: Dictionary<unknown>) {
  if (!path) {
    return ''
  }
  try {
    let url = base ? new URL(path, base).href : path
    if (params && !_.every(_.values(params), _.isEmpty)) {
      url += `?${stringifyGetParams(params)}`
    }
    return url
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(`Cannot format url - base:${base} path:${path}`)
    return ''
  }
}

export function formatPath(path?: string, params?: Dictionary<unknown>) {
  return formatUrl('', path, params)
}
